export default __webpack_public_path__ + "media/projects/onboarding-0299a045.mp4";